export default function parseEmail(email) {
    return email === null || email === void 0 ? void 0 : email.replace(/^(.{0,4}).*@/, "$1***@");
}
